import React from 'react'
import { PostItem } from './PostItem'

const posts = [
  {
    id: '1',
    title: 'Why Design Matters in Frontend Development',
    date: 'March 12, 2026',
    tag: 'Design',
    excerpt:
      'A great interface is more than working code. Users judge products quickly, and thoughtful design helps bridge user needs with business goals.',
    readTime: '5 min read',
  },
  {
    id: '2',
    title: 'Building Scalable React Applications',
    date: 'February 28, 2026',
    tag: 'React',
    excerpt:
      'Component structure, routing, and state management patterns that keep React projects maintainable as they grow over time.',
    readTime: '7 min read',
  },
  {
    id: '3',
    title: 'From NajotTalim to Real Projects',
    date: 'January 15, 2026',
    tag: 'Career',
    excerpt:
      'Lessons learned during 2+ years of frontend work — from learning fundamentals to shipping production websites for real clients.',
    readTime: '4 min read',
  },
  {
    id: '4',
    title: 'CSS Techniques for Modern Layouts',
    date: 'December 8, 2025',
    tag: 'CSS',
    excerpt:
      'Flexbox, Grid, and responsive patterns I use daily to create layouts that work across desktop and mobile screens.',
    readTime: '6 min read',
  },
  {
    id: '5',
    title: 'Working with Teams on Large Products',
    date: 'November 20, 2025',
    tag: 'Teamwork',
    excerpt:
      'How collaboration, code reviews, and clear communication help deliver better sites when working with a large development team.',
    readTime: '5 min read',
  },
  {
    id: '6',
    title: 'Optimizing Performance in Web Apps',
    date: 'October 3, 2025',
    tag: 'Performance',
    excerpt:
      'Practical tips for faster load times: image optimization, lazy loading, and keeping bundle sizes under control.',
    readTime: '8 min read',
  },
]

export const PostList = () => {
  return (
    <ul className="posts-list">
      {posts.map((post) => (
        <PostItem key={post.id} {...post} />
      ))}
    </ul>
  )
}
